import { render, staticRenderFns } from "./manageQuickReply.vue?vue&type=template&id=548696a8&"
import script from "./manageQuickReply.vue?vue&type=script&lang=js&"
export * from "./manageQuickReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports